/** Inserted by the Tab key in a code textarea. */
const CODE_INDENT = '  ';

/**
 * Replaces the selection of `textarea` with `text` the way typing does, so the browser's own undo
 * (Ctrl+Z) reverts it. Where the browser refuses the `insertText` editing command, the text is
 * set directly instead; that edit works the same but cannot be undone with Ctrl+Z. Either way an
 * `input` event reports the change.
 *
 * @param {HTMLTextAreaElement} textarea
 * @param {string} text
 */
function insertText(textarea, text) {
    textarea.focus();
    if (textarea.ownerDocument.execCommand('insertText', false, text)) {
        return;
    }
    textarea.setRangeText(text, textarea.selectionStart, textarea.selectionEnd, 'end');
    textarea.dispatchEvent(new Event('input', {bubbles: true}));
}

/**
 * Replaces the whole content of `textarea` with `text` as one undoable edit; see `insertText`.
 *
 * @param {HTMLTextAreaElement} textarea
 * @param {string} text
 */
export function replaceText(textarea, text) {
    textarea.focus();
    textarea.select();
    insertText(textarea, text);
}

/**
 * Makes Tab indent inside `textarea` instead of moving focus, the way code editors behave.
 * Keyboard users still get out: Esc followed by Tab moves focus on as usual, and so does
 * Shift+Tab (backwards) or Tab combined with another modifier.
 *
 * @param {HTMLTextAreaElement} textarea
 */
export function enableCodeEditing(textarea) {
    let tabLeavesEditor = false;
    textarea.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
            tabLeavesEditor = true;
            return;
        }
        const plainTab = e.key === 'Tab' && !e.shiftKey && !e.ctrlKey && !e.altKey && !e.metaKey;
        if (!plainTab || tabLeavesEditor) {
            tabLeavesEditor = false;
            return;
        }
        e.preventDefault();
        insertText(textarea, CODE_INDENT);
    });
    textarea.addEventListener('blur', () => {
        tabLeavesEditor = false;
    });
}
